import React, { Component } from 'react';
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import 'react-bootstrap';
import { withRouter } from 'react-router-dom';
import blogApi from "../../../api/blogApi";
import store from '../../../store/configureStore';
import TestimonialBlock from './TestimonialBlock';
import { addNotification } from "../../../actions/notificationAction";
import { changeHomeSectionAction } from '../../../actions/homeSectionAction';
import { Businesses } from '../../../config/Helper';
import { lang } from '../../../config/lang';
import { setBlogBusinessAction } from '../../../actions/blogAction'
class TestimonialSection extends Component {

    constructor(props) {
        super(props);
        this.state = {
            arrTestimonials: []
        }
        this.getTestimonials = this.getTestimonials.bind(this);
    }

    componentWillMount() {

    }

    componentDidMount() {
        this.getTestimonials(true);
    }

    componentWillUnmount() {

    }

    componentDidUpdate() {
        window.playVideo();
    }

    componentWillReceiveProps(newProps) {
        if (this.props.language.lang_key !== newProps.language.lang_key) {
            this.getTestimonials(false);
        }
    }

    getTestimonials(isNew) {
        blogApi.getBlogsWithPage(1, 'experience', '', '', 'u', 'y', 3).then((json) => {
            if (json.status === 200) {
                this.setState({
                    arrTestimonials: json.data.data.length > 6 ? json.data.data.slice(0, 6) : json.data.data
                });

                if (json.data.data.length > 0) {
                    store.dispatch(changeHomeSectionAction({ experience: true }));
                }

                if (isNew) {
                    window.contentWayPoint();
                    window.InitWOW();
                }
            } else {
                store.dispatch(addNotification(`${lang('server_err')}`, 'error'));
            }
        })
    }

    goToExperience() {
        store.dispatch(setBlogBusinessAction(Businesses.indexOf('experience')))
        this.props.history.push('/blog')
    }

    render() {

        if (this.state.arrTestimonials.length === 0) {
            return (
                <div />
            );
        }

        return (
            <section className="ftco-section bg-light" id="experience-section">
                <div className="container">
                    <div className="row justify-content-center heading" style={{ marginBottom: '10px !important' }}>
                        <div className="col-md-7 heading-section text-center ftco-animate">
                            <h2 className="mb-4">{this.props.title}</h2>
                            <p>{this.props.sub_title}</p>
                        </div>
                    </div>
                </div>
                <div className="container">
                    <div className="row">
                        {
                            this.state.arrTestimonials.map((testimonial, key) => (

                                <TestimonialBlock
                                    key={key}
                                    business={testimonial.business}
                                    id={testimonial.id}
                                    title={testimonial.title}
                                    description={testimonial.description}
                                    others={testimonial.others}
                                    image={testimonial.media_filename}
                                    media_type={testimonial.media_filetype} />

                            ))
                        }

                        <div className="col-md-12 animate-box text-center mt-3">
                            <button className="btn btn-primary btn-outline-primary" onClick={() => { this.goToExperience() }}>{lang('view_all')}<i className="ion-ios-arrow-forward"></i></button>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

function mapStateToProps(state) {
    return {
        language: state.language
    };
}

export default withRouter(connect(mapStateToProps)(TestimonialSection));